<template>
    <div class="sum" >
<!--        <el-card >-->
<!--            <el-breadcrumb separator="/">-->
<!--                &lt;!&ndash; <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item> &ndash;&gt;-->
<!--                <el-breadcrumb-item>数据看板</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>采购统计</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" size="mini">
                    <el-form-item label="年度" size="mini">
                        <el-date-picker :picker-options="pickerOptions"
                                type="years"
                                v-model="searchForm.year"
                                value-format="yyyy"
                                @change="changeYear"
                                placeholder="选择一个或多个年"
                                clearable>
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="月度" size="mini">
                        <el-date-picker
                                v-model="searchForm.month"
                                value-format="yyyy-MM"
                                type="months" @change="changeMonth" :picker-options="pickerOptions"
                                placeholder="选择月"
                                clearable>
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="季度" size="mini">
                        <Quarter @func="getMsg" @clear="clearQuarter" v-model="searchForm.quarter" @change="changeQuarter" ref="quarter0"/>
                    </el-form-item>
                    <el-form-item label="公司" prop="companyId" size="mini">
                        <el-select v-model="searchForm.companyIds"  placeholder="公司"
                                   multiple clearable style="width: 220px">
                            <el-option
                                    v-for="item in companys"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="日期范围" size="mini">
                        <el-date-picker v-model="searchForm.timeDate" type="daterange" range-separator="至" start-placeholder="开始日期" @change="changeTwo"
                            end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions" clearable >
                        </el-date-picker>
                    </el-form-item>
<!--                    <el-form-item label="季度">-->
<!--                        <el-select v-model="searchForm.quarter" placeholder="季度"-->
<!--                                   :disabled="searchForm.year == null || searchForm.year.length == 0 "-->
<!--                                   @change="changeQuarter" clearable>-->
<!--                            <el-option label="第1季度" value="1"></el-option>-->
<!--                            <el-option label="第2季度" value="2"></el-option>-->
<!--                            <el-option label="第3季度" value="3"></el-option>-->
<!--                            <el-option label="第4季度" value="4"></el-option>-->
<!--                        </el-select>-->
<!--                    </el-form-item>-->

                    <!-- <el-form-item label="日期">
                        <el-date-picker
                                @change="changeDay"
                                value-format="yyyy-MM-dd"

                                v-model="searchForm.day"
                                type="dates" :picker-options="pickerOptions"
                                placeholder="选择日期" clearable>
                        </el-date-picker>
                    </el-form-item> -->





                    <!--                    <el-form-item label="用户邮箱">-->
<!--                        <el-input v-model="searchForm.email" placeholder="用户邮箱" size="mini" clearable></el-input>-->
<!--                    </el-form-item>-->
<!--                    <el-form-item label="收货人">-->
<!--                        <el-input v-model="searchForm.consignee" placeholder="收货人" size="mini" clearable></el-input>-->
<!--                    </el-form-item>-->
<!--                    <el-form-item label="收货人手机">-->
<!--                        <el-input v-model="searchForm.mobile" placeholder="收货人手机" size="mini" clearable></el-input>-->
<!--                    </el-form-item>-->
<!--                    <el-form-item label="收货地址">-->
<!--                        <el-input v-model="searchForm.address" placeholder="收货地址" size="mini" clearable></el-input>-->
<!--                    </el-form-item>-->
<!--                    <el-form-item label="订单编号">-->
<!--                        <el-input v-model="searchForm.orderBatch" placeholder="订单编号" size="mini" clearable></el-input>-->
<!--                    </el-form-item>-->
<!--                    <el-form-item label="状态">-->
<!--                        <el-select v-model="searchForm.status" placeholder="状态" size="mini" clearable>-->
<!--                            <el-option label="全部" value=""></el-option>-->
<!--                            <el-option label="待下单" value="0"></el-option>-->
<!--                            <el-option label="已下单" value="2"></el-option>-->
<!--                            <el-option label="已发货" value="3"></el-option>-->
<!--                            <el-option label="已取消" value="5"></el-option>-->
<!--                            <el-option label="已驳回" value="6"></el-option>-->
<!--                        </el-select>-->
<!--                    </el-form-item>-->
                    <el-form-item size="mini">
                        <el-button type="primary" @click="onSearch" >查询</el-button>
                    </el-form-item>
                </el-form>
                <el-row :gutter="20">
                    <el-col :span="16">
                        <el-card class="box-card" shadow="hover" style="width: 100%">
                            <div slot="header" class="clearfix">
                                <span>{{searchForm.year || searchForm.month || searchForm.quarter || searchForm.beginDate || searchForm.endDate ? '筛选周期的物料金额' : '最近7天物料金额'}}</span>
                            </div>
                            <div style="width:100%;height:440px;" ref="chartsRegister"></div>
                        </el-card>
                    </el-col>
                    <el-col :span="8">
                        <el-card class="box-card" style="width: 100%" shadow="hover">
                            <el-table
                                    stripe
                                    :data="tableData"
                                    v-loading="loading"
                                    style="width: 100%" height="500">

                                <el-table-column
                                        prop="companyName" width="auto" :min-width="120"
                                        label="公司" >
                                </el-table-column>
                                <el-table-column
                                        prop="day"
                                        label="时段" width="120">
                                </el-table-column>

                                <el-table-column
                                        prop="totalPrice"
                                        label="订单金额(元)" width="120">
                                </el-table-column>
                                <!--                    <el-table-column-->
                                <!--                        prop="consignee"-->
                                <!--                        label="月度合计(金额)" width="140">-->
                                <!--                    </el-table-column>-->
                                <!--                    <el-table-column-->
                                <!--                        prop="mobile"-->
                                <!--                        label="季度合计(金额)" width="140">-->
                                <!--                    </el-table-column>-->
                                <!--                    <el-table-column-->
                                <!--                        prop="mobile"-->
                                <!--                        label="年度合计(金额)" width="140">-->
                                <!--                    </el-table-column>-->

                                <!--                    <el-table-column-->
                                <!--                        prop="orderBatch"-->
                                <!--                        label="订单编号" width="120">-->
                                <!--                    </el-table-column>-->



                            </el-table>
                        </el-card>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-card class="box-card" shadow="hover" style="width: 100%; margin-top: 10px">
                            <div style="width:100%;height:440px;" ref="chartsRegister2"></div>
                        </el-card>
                    </el-col>
                </el-row>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                        background
                        layout="sizes,prev, pager, next"
                        :page-sizes="[10, 20, 50, 100]"
                        v-if="total>0"
                        :total="total"
                        :page-size="pageSize"
                        @size-change="handleSizeChange"
                        @current-change="onPageChange"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>

        <el-dialog title="导出订单" :visible.sync="exportOrderVisible" :close-on-click-modal="false" width="500px">
            <el-form ref="exportOrderForm" :model="exportOrderForm" :rules="rules" label-width="100px">
                <el-form-item label="订单编号" prop="orderBatch">
                    <el-input v-model="exportOrderForm.orderBatch" placeholder="请输入订单编号" size="mini" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="exportOrderVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportOrder">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog title="" :visible.sync="reviewVisible" :close-on-click-modal="false" width="500px">
            <el-form ref="reviewForm" :model="reviewForm" :rules="rules" label-width="100px">
                <el-form-item label="审核结果" prop="pass"  v-if="false">
                    <el-select v-model="reviewForm.pass" placeholder="" clearable>
                        <el-option label="通过" value="true"></el-option>
                        <el-option label="拒绝" value="false"></el-option>

                    </el-select>
                </el-form-item>
                <el-form-item label="驳回原因" prop="reason" v-if='reviewForm.pass == "false"'>
                    <el-input v-model="reviewForm.reason" placeholder="请输入驳回原因" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="reviewVisible = false">取 消</el-button>
                <el-button type="primary" @click="addProcess()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { downloadByPost, convertRes2Blob } from '../../utils/download.js';
import * as echarts from "echarts";
import Quarter from "../../components/Quarter";
export default {
    components: {Quarter},
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
           companys:[],
            reviewVisible:false,
            value6: "",
            searchForm: {
                companyIds: [],
                timeDate: "",
                year: "",
                day: "",
                month: "",
                quarter: "",
                beginDate: "",
                endDate: "",
            },
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],

            addOrderForm: {
                id: "",
                orderBatch: "",
            },
            exportOrderVisible: false,
            exportOrderForm: {
                orderBatch: "",
            },

            orderForm: {
                orderBatch: "",
            },
            reviewForm: {
                name:"",//收货人
                pass:true,
                reason: "",
                workflowId:"",
                step:"",
                orderId:"",
                totalPrice:""

            },
            selectData:[],//选中的数据
            rules: {
                orderBatch: [
                    { required: true, message: '请输入订单编号', trigger: 'blur' }
                ],
            },
        }
    },
    methods: {
        onSearch() {
            this.loading = true;
            this.selectData = [];
            let _this = this
            let ids = null;
            //let cond = {...this.searchForm};
            if(this.searchForm.companyIds.length>0) {
                ids = this.searchForm.companyIds;
            }

            let data = {
                companyIds:ids,

            }
            if(this.searchForm.year && this.searchForm.year.length>0) {
                data.year = this.searchForm.year.sort();
            }
            if(this.searchForm.day && this.searchForm.day.length>0) {
                data.day = this.searchForm.day.sort();
            }
            if(this.searchForm.month && this.searchForm.month.length>0) {
                data.month = this.searchForm.month.sort();
            }

            if(this.searchForm.quarter && this.searchForm.quarter.length>0) {
                data.quarter = this.searchForm.quarter;
            }
            if(this.searchForm.timeDate != "" &&this.searchForm.timeDate!=null) {
                data["beginDate"] = this.searchForm.timeDate[0];
                data["endDate"] = this.searchForm.timeDate[1];
            }
            this.$axios.post("/admin/statistics/companyOrder",data).then(function(response) {
                let resp = response.data;

                if( resp.header.status == 0) {

                    _this.loading = false;
                    {
                        if(!_this.chartsRegister){
                            _this.chartsRegister = echarts.init(_this.$refs.chartsRegister);
                        }else{
                            _this.chartsRegister.clear();
                        }

                        let series = [];
                        let legend = [];
                        let keys = [];
                        if(resp.data && resp.data.length>0){
                            if(ids == null || ids.length == 0){
                                ids = resp.data[0].value.map(it => it.companyName);
                            }

                            for(let i=0; i<ids.length; i++){
                                let name = resp.data[0].value[i].companyName;
                                legend.push(name);
                            }
                            let data = resp.data;

                            for(let j=0; j<data.length; j++) {
                                keys.push(data[j].key);
                            }
                            for(let i=0; i<legend.length; i++){
                                let name = legend[i];
                                let res = [];
                                for(let j=0; j<data.length; j++){
                                    let v = data[j].value;
                                    let d =  v.filter(vo => vo.companyName == name)[0].totalPrice;
                                    const allTotalPrice = data.map(it => ({x: it.key, y: it.value.filter(v => v.companyName === name)[0].totalPrice}));
                                    res.push({value: d, allTotalPrice});
                                }

                                series.push({
                                    name: name,
                                    type: 'line',
                                    tooltip: {
                                        // valueFormatter: value => value + ' 元',
                                        formatter: (params) => {
                                            // console.log(params);
                                            let tooltip = '';
                                            tooltip += `${params.marker || ''} ${params.seriesName || ''}<br /><br />`;
                                            for(let k=0; k<params.data.allTotalPrice.length; k++) {
                                                const it = params.data.allTotalPrice[k];
                                                tooltip += `<div style='display: flex; width: 200px'><div style='margin-right: 10px; display: inline-block'>${it.x || ''}</div><div style='flex-grow: 1; display: inline-block' align='right'>${it.y}元</div></div>`;
                                            }
                                            return tooltip;
                                        }
                                    },
                                    data: res,
                                    emphasis: {
                                        focus: 'series'
                                    },
                                    node: 'abc',
                                });
                            }
                            let allData = [];

                            for(let i=0; i<resp.data.length; i++){

                                allData =  allData.concat(resp.data[i].value);
                            }
                            //allData.sort((a,b)=>a.day.localeCompare(b.day));
                            allData.sort((a,b)=> {
                                if(a.totalPrice - b.totalPrice > 0.01) {
                                    return -1;
                                } else if(Math.abs(a.totalPrice - b.totalPrice) <= 0.01) {
                                    return a.companyName.localeCompare(b.companyName);
                                } else {
                                    return 1;
                                }
                            });

                            _this.tableData = allData;

                            let optionRegister = {
                                // title: {
                                //     text: '物料金额统计'
                                // },
                                tooltip: {
                                    show: true,
                                    trigger: 'item',
            //                         formatter: (params) => {
            //                             console.log(params);
            //                             let tooltip = '';
            //                             tooltip += `${params.marker || ''} ${params.name || ''} <br />`;
            // // str += `Purchaser#: ${params?.data?.value} <br />`;
            // // str += `Weight : ${numeral(params?.data?.weight ?? null).format(
            // //   '0.0%',
            // // ) ?? NaNPlaceholder} <br />`;

            //                             return tooltip;
            //                         },
                                },
                                legend: {
                                    data:legend,
                                    type: 'scroll',
                                },
                                xAxis: [
                                    {
                                        type: 'category',
                                        data: resp.data.map(it => it.key),
                                        axisPointer: {
                                            type: 'shadow'
                                        }
                                    }
                                ],
                                yAxis: [
                                    {
                                        type: 'value',
                                        alignTicks: true,
                                        axisLabel: {
                                            formatter: '{value} 元'
                                        }
                                    },
                                ],
                                series:series
                            };

                            _this.chartsRegister.setOption(optionRegister);
                        }
                    }


                    {
                        if(!_this.chartsRegister2){
                            _this.chartsRegister2 = echarts.init(_this.$refs.chartsRegister2);
                        }else{
                            _this.chartsRegister2.clear();
                        }

                        let series = [];
                        let legend = [];
                        let keys = [];
                        if(resp.data && resp.data.length>0){
                            if(ids == null || ids.length == 0){
                                ids = resp.data[0].value.map(it => it.companyName);
                            }

                            for(let i=0; i<ids.length; i++){
                                let name = resp.data[0].value[i].companyName;
                                legend.push(name);
                            }
                            let data = resp.data;

                            for(let j=0; j<data.length; j++) {
                                keys.push(data[j].key);
                            }
                            for(let i=0; i<legend.length; i++){
                                let name = legend[i];
                                let res = [];
                                for(let j=0; j<data.length; j++){
                                    let v = data[j].value;
                                    let d =  v.filter(vo => vo.companyName == name)[0].totalPrice;
                                    const allTotalPrice = data.map(it => ({x: it.key, y: it.value.filter(v => v.companyName === name)[0].totalPrice}));
                                    res.push({value: d, allTotalPrice});
                                }

                                series.push({
                                    name: name,
                                    type: 'line',
                                    data: res,
                                });
                            }
                            let allData = [];

                            for(let i=0; i<resp.data.length; i++){

                                allData =  allData.concat(resp.data[i].value);
                            }
                            //allData.sort((a,b)=>a.day.localeCompare(b.day));
                            allData.sort((a,b)=> {
                                if(a.totalPrice - b.totalPrice > 0.01) {
                                    return -1;
                                } else if(Math.abs(a.totalPrice - b.totalPrice) <= 0.01) {
                                    return a.companyName.localeCompare(b.companyName);
                                } else {
                                    return 1;
                                }
                            });

                            _this.tableData = allData;

                            let optionRegister = {
                                // title: {
                                //     text: '物料金额统计'
                                // },
                                tooltip: {
                                    show: true,
                                    trigger: 'axis',
                                    tooltip: {
                                        valueFormatter: value => value + ' 元'
                                    },
            //                         formatter: (params) => {
            //                             console.log(params);
            //                             let tooltip = '';
            //                             tooltip += `${params.marker || ''} ${params.name || ''} <br />`;
            // // str += `Purchaser#: ${params?.data?.value} <br />`;
            // // str += `Weight : ${numeral(params?.data?.weight ?? null).format(
            // //   '0.0%',
            // // ) ?? NaNPlaceholder} <br />`;

            //                             return tooltip;
            //                         },
                                },
                                legend: {
                                    data:legend,
                                    type: 'scroll',
                                },
                                xAxis: [
                                    {
                                        type: 'category',
                                        data: resp.data.map(it => it.key),
                                        axisPointer: {
                                            type: 'shadow'
                                        }
                                    }
                                ],
                                yAxis: [
                                    {
                                        type: 'value',
                                        alignTicks: true,
                                        axisLabel: {
                                            formatter: '{value} 元'
                                        }
                                    },
                                ],
                                series:series
                            };

                            _this.chartsRegister2.setOption(optionRegister);
                        }
                    }

                }
            }).catch(function() {
            });
        },

        clearQuarter() {
            this.searchForm.quarter = null;
        },

        exportOrder() {
            const that = this;
            this.$refs.exportOrderForm.validate(valid => {
                if(valid) {
                    downloadByPost({
                        axios: that.$axios,
                        url: "/admin/rfq/exportCustomerOrderDetail",
                        data: that.exportOrderForm,
                        success: response => {
                            convertRes2Blob(response);
                        },
                    });
                }
            });
        },

        order() {
            const that = this;
            this.$refs.orderForm.validate(valid => {
                if(valid) {
                    this.$axios.post("/admin/order/customerOrder", this.orderForm)
                    .then(function (response) {
                        let resp = response.data;
                        if (resp.header.status == 0) {
                            that.$notify({
                                title: '成功',
                                message: '数据保存成功',
                                type: 'success'
                            });
                            that.orderVisible = false;
                            that.onSearch();
                        } else {
                            that.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
                }
            });
        },
        passIt(orderId,step,workflowId,name,totalPrice){
            this.reviewForm.pass = 'true';
            this.reviewForm.reason = '';
            this.reviewForm.orderId = orderId;
            this.reviewForm.step = step;
            this.reviewForm.workflowId = workflowId;
            this.reviewForm.name = name;
            this.reviewForm.totalPrice = totalPrice;
            this.addProcess();
        },
        showReviewDialog(orderId,step,workflowId,name,totalPrice) {//打开审核对话框
            this.reviewForm.pass = 'false';
            this.reviewForm.reason = '';
            this.reviewForm.orderId = orderId;
            this.reviewForm.step = step;
            this.reviewForm.workflowId = workflowId;
            this.reviewForm.name = name;
            this.reviewForm.totalPrice = totalPrice;
            this.reviewVisible = true;

        },
        addProcess() {//添加审核过程
            // step,pass,orderId,WorkflowId,reason


               //确定通过abc提交的总价￥123,456,78的订单吗?

            const that = this;
            let cond = {...this.reviewForm};
            let optate = "通过";
            optate = cond.pass == 'false' ? "驳回" : "通过";
            this.$confirm('确定' + optate +'【' +cond.name+'】提交的总价【￥'+cond.totalPrice+'】的订单吗？', '提示', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {

                cond.pass = cond.pass == 'true' ? true : false;
                if (cond.pass) {
                    cond.reason = '';
                }
                cond={pass:cond.pass,reason:cond.reason,orderId:cond.orderId,step:cond.step
                    ,workflowId:cond.workflowId};
                this.$axios.post("/admin/rfq/review", cond)
                    .then(function (response) {
                        let resp = response.data;
                        if (resp.header.status == 0) {

                            that.reviewVisible = false;
                            if (resp.data == true) {//审核完毕
                                that.changeOrder(that.reviewForm.orderId);
                                that.onSearch();
                            } else {
                                that.$notify({
                                    title: '成功',
                                    message: '数据保存成功',
                                    type: 'success'
                                });
                                that.onSearch();
                            }

                        } else {
                            that.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
            });





        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        handleToReviewDetail(row) {
            let showBtn = (row.status == 0&&row.review);

            this.$router.push({name: "customerReviewDetail", params: {from: "rfq", orderId: row.id,
                    step:row.reviewStep, workflowId:row.workflowId, name:row.consignee,totalPrice:row.totalPrice,showBtn:showBtn}})



        },
        handleToDeliver(row) {

            this.$router.push({name: "deliver", params: {from: "order", orderId: row.id
                   }});
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        exportOrderDialogNew(){
            if(this.selectData.length == 0){
                this.$message({
                    type: 'info',
                    message: '请选择要导出的订单',
                    duration: 2000
                });
                return;
            }
            const that = this;
            let arr = [];
            let val = this.selectData;
            if(val.length>0){
                for(let i=0; i<val.length; i++){
                    arr.push(val[i].id);
                }
                downloadByPost({
                    axios: that.$axios,
                    url: "/admin/easypoi/order",
                    data: arr,
                    success: response => {
                        convertRes2Blob(response);
                    },
                });
            }
        },
        exportDeliver(){
            if(this.selectData.length == 0){
                this.$message({
                    type: 'info',
                    message: '请选择要导出的订单',
                    duration: 2000
                });
                return;
            }
            const that = this;
            let arr = [];
            let val = this.selectData;
            if(val.length>0){
                for(let i=0; i<val.length; i++){
                    arr.push(val[i].id);
                }
                downloadByPost({
                    axios: that.$axios,
                    url: "/admin/easypoi/deliver",
                    data: arr,
                    success: response => {
                        convertRes2Blob(response);
                    },
                });
            }
        },
        loadCompanys(){
            let _this = this
            this.$axios.post("/admin/company/companys"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.companys = resp.data;
                }

            });

        },
        changeTwo(value){
            if(value != null){
                this.searchForm.day = "";
                this.searchForm.month = "";
                this.$bus.$emit('reset',true);
                this.searchForm.quarter = "";

            }


        },
        changeYear(value){
            if(value != null){
                this.searchForm.day = "";
                this.searchForm.month = "";
                this.$bus.$emit('reset',true);
                this.searchForm.timeDate = "";
                this.searchForm.quarter = "";

            }


        },
        changeQuarter (value){

            if(value != null){
                this.searchForm.day = "";
                this.searchForm.month = "";
                this.searchForm.year = "";
                this.searchForm.timeDate = "";
            }

        },
        changeMonth(value){
            if(value != null){
                this.searchForm.day = "";
                this.searchForm.year = "";
                this.$bus.$emit('reset',true);
                this.searchForm.timeDate = "";
                this.searchForm.quarter = "";
                //this.$refs.quarter0.reset();
                //this.searchForm.quarter = "";
            }

        },
        changeDay(value){
            if(value != null){
                this.searchForm.year = "";
                this.searchForm.month = "";
                this.$bus.$emit('reset',true);
                this.searchForm.timeDate = "";
                this.searchForm.quarter = "";

            }


        },
        getMsg(value){

            this.searchForm.quarter = value;
            if(value != null){
                this.searchForm.day = "";
                this.searchForm.month = "";
                this.searchForm.year = "";
                this.searchForm.timeDate = "";
            }
        }
    },
    created() {

        this.onSearch();
        this.loadCompanys();
    },
}
</script>
